



























import DragNDropBase from "@share/common/controls/file/drag-n-drop/DragNDropBase.vue";
import { Component, Prop } from "vue-property-decorator";
import PlusIcon from "@share/common/PlusIcon.vue";
import { validateFilesExt, validateFileSize } from "@common/fileInputHelper";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Spinner from "@share/chat/components/Spinner.vue";
import PencilIcon from "@share/event-edit/components/PencilIcon.vue";

@Component({
    name: "EventEditFileUpload",
    components: {PencilIcon, Spinner, BounceSpinner, PlusIcon}
})
export default class EventEditFileUpload extends DragNDropBase {
    @Prop({default: false}) isLoading: boolean;
    @Prop({default: false}) hasFile: boolean;

    maxFileSize = 5;
    allowedExtensions = ['png', 'jpg', 'jpeg'];
    invalidExtensions: string[] = [];

    get extensions() {
        return this.allowedExtensions.map(ext => '.' + ext).join(", ");
    }

    get maxFileSizeStr() {
        return [this.$t("common.max").toString().toLocaleLowerCase(), this.maxFileSize, this.$t("common.mB")].join(' ');
    }

    get minResolution() {
        return this.$t("common.min").toString().toLowerCase() + ' 1436x428 ' + this.$t('event.form.proportionsHint');
    }

    get hintText() {
        return '(' + [this.extensions, this.maxFileSizeStr, this.minResolution].filter(item => item).join(', ') + ')';
    }

    handleDrop(event: DragEvent) {
        this.handleFiles((event.dataTransfer?.files ?? null));
    }

    handleInput(event: Event) {
        this.handleFiles((event.target as HTMLInputElement).files);
    }

    handleFiles(fileList: FileList | null) {
        if(!fileList?.length)  { return; }

        this.invalidExtensions = [];
        const files = Array.from(fileList);
        const validatedFiles = validateFilesExt(files, this.allowedExtensions);

        if(validatedFiles.invalid.length) {
            this.invalidExtensions = validatedFiles.invalid.map(file => file.name)
            return
        }

        if (!validateFileSize(files[0], this.maxFileSize)) {
            window.alert('to big');
            //@todo show message
            return;
        }

        this.$emit('change', files[0]);
    }
}
